import i18n from "i18next";
import { initReactI18next } from "react-i18next";

import translationEN from "./locales/en.json"; // English translations
import translationES from "./locales/es.json"; // French translations

const resources = {
  en: {
    translation: translationEN,
  },
  es: {
    translation: translationES,
  },
};

i18n.use(initReactI18next).init({
  resources,
  lng: localStorage.getItem("selectedLanguage") || "en", // Default language
  interpolation: {
    escapeValue: false,
  },
});

export default i18n;
